import React, { memo, useCallback } from 'react';
import { useAppDispatch } from '../../../store//hooks';
import { View } from '../../../store/types';
import { flipView } from '../../../store/reducer';
import { Container } from './NoCheggAccount.styles';
import { ErrorLink } from '../../../components/shared.styles';
import { getTexts } from '../../../lib/contentful/defaultTexts';
var NoCheggAccount = function NoCheggAccount() {
  var dispatch = useAppDispatch();
  var _getTexts = getTexts(),
    _getTexts$login = _getTexts.login,
    noCheggAccountText = _getTexts$login.noCheggAccountText,
    createAnAccountText = _getTexts$login.createAnAccountText;
  var flipToSignup = useCallback(function (e) {
    e.preventDefault();
    dispatch(flipView({
      view: View.SIGNUP
    }));
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(Container, {
    "data-test": "no_chegg_account"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, noCheggAccountText, " "), /*#__PURE__*/React.createElement(ErrorLink, {
    "data-test": "no_chegg_account_flip_to_signup",
    onClick: flipToSignup
  }, createAnAccountText)));
};
export default /*#__PURE__*/memo(NoCheggAccount);